export function contactHints(text:string){
 const email=text.match(/[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/i)?.[0]||'';
 const candidate=text.match(/(?:\+\d|0\d)[\d ()-]{7,}\d/)?.[0]||'';
 const digits=candidate.replace(/\D/g,'');
 return {email,phone:digits.length>=9&&digits.length<=15?candidate.trim():''};
}
